import { ApolloError, gql } from '@apollo/client'
import { BannerContent } from 'features/StoryblokContent/BannerContent'

import { DebitCardAccountStatus } from 'types/gql-global-types'

import { useGoToSavingsAccountLearnMore } from '../../../../../features/SavingsAccountLearnMore/savings-account-learn-more-routing'
import { SavingsAccountOverviewBannerDebitCardAccountV2Fragment } from '../../../../../types/gql-types/SavingsAccountOverviewBannerDebitCardAccountV2Fragment'
import { SavingsAccountOverviewBannerEntityFragment } from '../../../../../types/gql-types/SavingsAccountOverviewBannerEntityFragment'
import { useGoToInternalTransfer } from '../../../../Transfer/hooks/useGoToInternalTransfer/useGoToInternalTransfer'

interface SavingsAccountOverviewBannerProps {
  savingsAccounts: SavingsAccountOverviewBannerDebitCardAccountV2Fragment[]
  interestRate?: SavingsAccountOverviewBannerEntityFragment | null
  isLoading: boolean
  error?: ApolloError
  hideOverviewBanner: () => void
}

export const SavingsAccountOverviewBanner = ({
  savingsAccounts,
  interestRate,
  isLoading,
  error,
  hideOverviewBanner,
}: SavingsAccountOverviewBannerProps) => {
  const { goToSavingsAccountLearnMore } = useGoToSavingsAccountLearnMore()
  const { goToInternalTransfer } = useGoToInternalTransfer()

  const activeSavingsAccount = savingsAccounts.find(
    (savingsAccount) => savingsAccount.status === DebitCardAccountStatus.ACTIVE
  )

  if (isLoading || error) {
    return null
  }

  if (!activeSavingsAccount) {
    return (
      <BannerContent
        hideOverviewBanner={hideOverviewBanner}
        onClick={(e) => {
          e.preventDefault()
          goToSavingsAccountLearnMore({
            stage: 'intro',
            interestRate:
              interestRate?.savingsAccountProduct?.effectiveInterestRate ?? '',
            canCreateAccount: interestRate?.canCreateAccount ?? null,
          })
        }}
        slug="dashboard-topline-banner-savings-march-activate"
      />
    )
  }

  return (
    <BannerContent
      hideOverviewBanner={hideOverviewBanner}
      onClick={(e) => {
        e.preventDefault()
        goToInternalTransfer({
          transferType: 'internal',
          from: '',
          to: activeSavingsAccount.id,
        })
      }}
      slug="dashboard-topline-banner-savings-march-topup"
    />
  )
}

SavingsAccountOverviewBanner.fragments = {
  DebitCardAccountV2: gql`
    fragment SavingsAccountOverviewBannerDebitCardAccountV2Fragment on DebitCardAccountV2 {
      id
      balance {
        value
      }
      status
    }
  `,

  Entity: gql`
    fragment SavingsAccountOverviewBannerEntityFragment on Entity {
      id
      savingsAccountProduct {
        id
        effectiveInterestRate
      }
      canCreateAccount
    }
  `,
}
